export default class BackofficeCustomersForm {

    constructor() {
        this.bindEvents();
        this.initializeSelect2();
    }

    bindEvents() {
    }

    initializeSelect2() {
        // Initialize select2 for the entity multiple select with search functionality
        $('.entities-select').select2({
            width: '100%',
            allowClear: true,
            closeOnSelect: false,
            minimumResultsForSearch: 10, // Show search box only if there are more than 10 options
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
        // Clean up Select2 to prevent memory leaks
        $('.entities-select').select2('destroy');
    }
}